import ChatToggleButton from "../ui-control/ChatToggleButton";
import useEmbedded from "../../hooks/useEmbedded";
import { useAddCaseFormContext } from "../../contexts/AddCaseFormContext";
import useHelpRequest from "../../hooks/useHelpRequest";
import { isFirstStep } from "../../constants/formSteps";
import GenerateDemandBtn from "./GenerateDemandBtn";
import XButton from "../common/XButton";
import GetHelpButton from "../ui-control/GetHelpButton";
import HelpRequestModal from "../ui-control/HelpRequestModal";

const CaseFormFooter = () => {
    const { presignedUrlGenerationCount, addCaseFormStep, backToCases, decrementAddCaseFormStep, isChatOpen, setIsChatOpen } = useAddCaseFormContext();
    const isUploading = presignedUrlGenerationCount > 0;
    const { isEmbedded } = useEmbedded();
    const { openHelpModal, helpRequestModalProps } = useHelpRequest();

    return (
        <footer className='bg-surface py-4! mt-6 border-t border-border fixed-footer'>
            <div className='container'>
                <div className='flex justify-between items-center btm-btns'>
                    <div className="flex items-center gap-5 text-center">
                        {!isEmbedded && (
                            <XButton
                                variant="link"
                                onClick={backToCases}
                                disabled={isUploading}
                            >
                                <i className='fa fa-arrow-left mr-2!'></i>Back to Case List
                            </XButton>
                        )}
                        <ChatToggleButton isChatOpen={isChatOpen} setIsChatOpen={setIsChatOpen} />
                        {isEmbedded && (<GetHelpButton onClick={openHelpModal} />)}
                    </div>
                    <div className="flex items-center gap-5 text-center">
                        {isUploading && (
                            <small className="text-body mr-4!">
                                <i className="fa fa-spinner animate-spin mr-1!"></i>
                                Uploading {presignedUrlGenerationCount} file(s)...
                            </small>
                        )}
                        <XButton
                            id="previous"
                            variant="link"
                            onClick={decrementAddCaseFormStep}
                            disabled={isFirstStep(addCaseFormStep) || isUploading}
                        >
                            <i className='fa fa-arrow-left'></i><span className="ml-2!">Previous</span>
                        </XButton>
                        <GenerateDemandBtn/>
                    </div>
                </div>
                {isEmbedded && <HelpRequestModal {...helpRequestModalProps} />}
            </div>
        </footer>
    )
}

export default CaseFormFooter

